<ng-container *ngIf="_customfields?.length > 0 && !_isCustomfieldLoading">
	<ng-container *ngFor="let field of _customfields">
		<ng-container *ngIf="!field.hidden || field.hidden?.toString() == '0'">
			<!-- Campos normais: passa campo individual ao generic-form-gen -->
			<cpi-generic-form-gen
				*ngIf="field.rawInputType !== 'json_dynamic'"
				[columns]="1"
				[labels]="labels"
				[setGenericForm]="[field]"
				[boldLabel]="false">
			</cpi-generic-form-gen>

			<!-- json_dynamic: componente dedicado e reutilizável -->
			<pcp-json-dynamic-field
				*ngIf="field.rawInputType === 'json_dynamic'"
				[field]="field"
				[disabled]="disabled"
				[labels]="labels"
				(valueChange)="verifyCustomfieldValues(false)">
			</pcp-json-dynamic-field>
		</ng-container>
	</ng-container>
</ng-container>

<cpi-dot-bounce-loading-effect *ngIf="_isCustomfieldLoading"> </cpi-dot-bounce-loading-effect>
